$(document).ready(function () {
  // General Message
  $('.generalmessage').prependTo('header');
  $('.emailInputSubmit a').text("Email Sign-Up");

});

$(window).load(function () {
  $('.viewcart').clone().appendTo('.cart-mobile');
  setTimeout(() => {
    $(".socialNetworks .socialNetworkIconTwitter").attr('target', '_blank');
    $(".socialNetworks .socialNetworkIconFacebook").attr('target', '_blank');
    $(".socialNetworks .socialNetworkIconYoutube").attr('target', '_blank');
    $(".socialNetworks .socialNetworkIconInstagram").attr('target', '_blank');
  }, 1000)

});


